export const DEFAULT_ACTION_PREFIX = 'KARNOTT_DEVICES';
export const DEFAULT_SERVICE_NAME = 'devices';
export const DEFAULT_ACCESSOR_CHAIN = [DEFAULT_SERVICE_NAME];
